<template>
  <div class="overview">
    <section class="stats columns has-text-centered">
      <div class="column">
        <article class="card">
          <div class="card-content">
            <p class="title">
              {{ stats.customers }}
              <b-icon
                v-if="stats.customers === null"
                icon="loading"
                custom-class="mdi-spin"
              />
            </p>

            <p class="subtitle">Kunder</p>
          </div>
        </article>
      </div>

      <div class="column">
        <article class="card">
          <div class="card-content">
            <p class="title">
              {{ stats.withActiveProjects }}
              <b-icon
                v-if="stats.withActiveProjects === null"
                icon="loading"
                custom-class="mdi-spin"
              />
            </p>

            <p class="subtitle">Med aktive projekter</p>
          </div>
        </article>
      </div>
    </section>

    <section class="columns">
      <div class="column">
        <div class="card">
          <header class="card-header">
            <p class="card-header-title">
              Alle Kunder
            </p>
          </header>

          <div class="card-content">
            <b-table
              :loading="loading"
              :data="customers"
              hoverable
              paginated
              pagination-simple
              :default-sort="['created_at', 'desc']"
              backend-pagination
              :current-page.sync="page"
              :total="total"
              :per-page="limit"
            >
              <template slot-scope="props">
                <b-table-column field="avatar" label="" width="10">
                  <avatar :account="props.row" :size="32" round />
                </b-table-column>

                <b-table-column field="name" label="Navn" sortable>
                  {{ props.row.name }}
                </b-table-column>

                <b-table-column field="company_name" label="Type" sortable>
                  <small v-if="props.row.company_name">
                    Virksomhed: {{ props.row.company_name }}
                  </small>

                  <small v-else>
                    Privatperson
                  </small>
                </b-table-column>

                <b-table-column
                  field="created_at"
                  label="Oprettet"
                  sortable
                  centered
                >
                  <span class="tag is-success">
                    {{ new Date(props.row.created_at).toISOString().split('T')[0] }}
                  </span>
                </b-table-column>

                <b-table-column field="projects" label="Projekter" sortable>
                  <small v-if="props.row.projects">
                    {{ props.row.projects.length }} projekter
                  </small>

                  <small class="has-text-warning" v-else>
                    Ingen projekter
                  </small>
                </b-table-column>

                <!--                                <b-table-column field="user.activated" label="Status" sortable>-->
                <!--                                    <span v-if="props.row.user.activated" class="tag is-small is-success">Aktiveret</span>-->
                <!--                                    <span v-else class="tag is-small is-danger">Deaktiveret</span>-->
                <!--                                </b-table-column>-->

                <b-table-column label="Handlinger" centered>
                  <router-link
                    class="button is-small"
                    :to="{
                      name: 'administration.customers.detail',
                      params: { id: props.row.id }
                    }"
                  >
                    <b-icon icon="information" size="is-small" />
                    <span>Detaljer</span>
                  </router-link>
                </b-table-column>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style lang="scss" scoped>
@import '../../../../global/styles/variables';

.new-tag {
  font-family: $family-primary !important;
}

.administration {
  background: #f5f7fa;
}
</style>

<script>
import Avatar from '@/taskflex/users/components/Avatar'
import CustomerService from '@/taskflex/customers/services/CustomerService'

export default {
  data () {
    return {
      customers: [],
      loading: false,
      total: 0,
      page: 1,
      limit: 999,
      stats: {
        customers: null,
        withActiveProjects: null
      }
    }
  },

  computed: {
    filter () {
      const { filter = null } = this.$route.meta

      return filter
    }
  },

  watch: {
    filter () {
      this.page = 1
    },

    page () {
      this.loadStudents()
    }
  },

  mounted () {
    this.loadStats()
    this.loadStudents()
  },

  methods: {
    loadStats () {
      CustomerService.count({}, ({ data }) => {
        this.stats.customers = data.count
      })

      const activeStudentsOptions = {
        filter_groups: [
          {
            filters: [
              {
                key: 'activeProjects',
                operator: 'eq',
                value: true
              }
            ]
          }
        ]
      }

      CustomerService.count(activeStudentsOptions, ({ data }) => {
        this.stats.withActiveProjects = data.count
      })
    },

    loadStudents () {
      this.loading = true

      const filters = []

      if (this.filter === 'active-projects') {
        filters.push({
          key: 'activeProjects',
          operator: 'eq',
          value: true
        })
      }

      const options = {
        page: this.page,
        limit: this.limit,

        includes: ['projects', 'user'],

        filter_groups: [
          {
            filters
          }
        ]
      }

      CustomerService.findAll(options, ({ data: { rows, total } }) => {
        this.customers = rows
        this.total = total

        this.loading = false
      })
    }
  },

  components: {
    Avatar
  }
}
</script>



// WEBPACK FOOTER //
// src/taskflex/administration/pages/customers/List.vue